// verifying (signing) the audit: one request, the result is put into the data.
const useEditorVerify = ({ uiContext, requestPost }) => {
  const verify = async ({
    username,
    password,
    verifLabel,
    id,
    result_object_id,
    result_object_datetime,
    result_object_data,
    data,
    setData,
  }) => {
    const body = { data_id: id, label: verifLabel };
    if (username) body["username"] = username;
    if (password) body["password"] = password;

    return await requestPost({
      fullUrl: `api/user/verif`,
      body: body,
      onSuccess: ({ message, data: responseData }) => {
        if (responseData) {
          const newData = { ...data };
          newData[result_object_id] = responseData[result_object_id];
          newData[result_object_datetime] =
            responseData[result_object_datetime];
          newData[result_object_data] = responseData[result_object_data];
          setData(newData);

          uiContext.showSuccessMsg("Success", "Verifikasi berhasil");
        }
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  return { verify };
};

export default useEditorVerify;
